/**
 * 旧的模型加载方式，不使用统一的 mlib
 * zhongyuliang 2022.03.28
 */

 import docService from "@/CommonDP/service/doc-service";

 export default {
   /**
      * 入口
      * @param { url 数据 } modelUrlData
      * @param { 模型加载参数 } opt
      */
   async load(modelUrlData, opt) {
     this.modelUrlData = modelUrlData;
     this.opt = opt || {};
     this.opt.isOssFile = true;
     this.resetModelData();
 
     if (this.modelUrlData.fileObj) { // 多文件
       await this.loadMultiModels();
     } else if (this.modelUrlData.fileId) { // 单文件
       await this.loadSingleModel();
     }
   },
 
   resetModelData() {
     this.models = [];
   },
   // 多文件
   async loadMultiModels() {
     const modelsarray = this.modelUrlData.fileObj;
     for (let i = 0; modelsarray.length > i; i++) {
       const model = modelsarray[i];
       const rvtId = model.folderID;
       const rvtVersion = model.rvtVersion;
       await this.queryLightFileDownloadUrls(rvtId, rvtVersion);
     }
     this.loadModel();
   },
 
   async loadSingleModel() { // 单个文件
     const rvtId = encodeURIComponent(this.modelUrlData.fileId);
     const rvtVersion = this.modelUrlData.rvtVersion;
     await this.queryLightFileDownloadUrls(rvtId, rvtVersion);
     this.loadModel();
   },
 
   async queryLightFileDownloadUrls(rvtId, rvtVersion) {
     const data = await this.queryModels(rvtId, rvtVersion);
     this.models = [...this.models,...data]
   },
 
   async queryModels(rvtId, rvtVersion) {
     try {
       const { data } = await docService.queryModelLightFilesFromMLib(rvtId, rvtVersion);
       const lightFileList = data.lightFileList || [];
       const bimexDetailFiles = lightFileList.map(item => {
         return {
           originFileName: item.lightFileName,
           url: item.downloadUrl,
           fileId: item.fileId,
           ...item
         };
       });
       const models = [];
       models.push({ bimexName: data.fileName, bimexId: data.fileId, bimexDetailList: bimexDetailFiles });
       return models;
     } catch (e) {
       console.error("查询轻量化文件失败：", e);
       return [];
     }
   },
 
   // 加载模型
   loadModel() {
     const models = this.models;
     Monge.Model.dispose();
     Monge.EngineResources = "./EngineResources";
     Monge.Model.LoadBimx("modelbox", models, this.opt);
   }
 }
 